import React, { Component } from "react";
// import axios from "axios";
import "react-responsive-modal/styles.css";
// import classnames from "classnames";
import { Modal } from "react-responsive-modal";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import {
  TextField,
  // FormControl, Select
} from "@material-ui/core";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
// import {
//   InputBoxComponent,
//   TextAreaReusableComponent,
// } from "../../inputReusableComponent/InputBoxComponent";
// import IncrementDecrement from "../../incrementDecrement/IncrementDecrement";
// import { SlidingComponent } from "../../slidingToggleComponent/SlidingComponent";
import { IconBoxReusableComponent } from "../../IconBoxReusable/IconBoxReusableComponent";
import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import { EditDetailsTop } from "./EditDetailsTop";
import { PopupIconButtonReusable } from "../allPopupReusableIconButton/PopupIconButtonReusable";
import InputNumberFunc from "../../../../function/InputNumberFunc";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { vendor_dashboard_edit_action } from "../../../../store/actions/dashboardAction/addingAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { InputCharacterCheck } from "../../../../function/InputCharNumCheckFunc";
import Switch from "react-switch";

export class EditDiner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      country_code: "",
      mobile_number: "",
      name: "",
      adult: 0,
      kids: 0,
      handicap: 0,
      highchair: 0,
      currentState: true,
      room_number: "",
      table_number: "",
      seating_preference: "",
      special_Ocassion: "",
      editDiner: {},
      editNumberName: {},
      allSeatingArea: [],
      errors: {},
      error: null,
      isLoading: false,
      hasSetEditProps: false,
      checkedBox: false,
    };
  }

  componentDidMount() {
    this.setState({
      editDiner: !isEmpty(this.props.dataSend) ? this.props.dataSend : "",
      editNumberName: !isEmpty(this.props.dataSend)
        ? this.props.dataSend.user_details
        : "",
      mobile_number: !isEmpty(this.props.dataSend)
        ? this.props.dataSend.user_details.mobile_number
        : "",
      seating_preference: !isEmpty(this.props.dataSend.seating_preference[0])
        ? this.props.dataSend.seating_preference[0]
        : "",
      kids: !isEmpty(this.props.dataSend.kids_count)
        ? this.props.dataSend.kids_count
        : "",
      adult: !isEmpty(this.props.dataSend.adult_count)
        ? this.props.dataSend.adult_count
        : "",
      handicap: !isEmpty(this.props.dataSend.handicap_chair)
        ? this.props.dataSend.handicap_chair
        : "",
      highchair: !isEmpty(this.props.dataSend.high_chair)
        ? this.props.dataSend.high_chair
        : "",
    });
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      nextProps.onboarding._id &&
      !isEmpty(nextProps.onboarding.selected_seating_area)
    ) {
      if (
        !isEmpty(nextProps.onboarding.selected_seating_area) &&
        !nextState.hasSetEditProps
      ) {
        return {
          allSeatingArea: !isEmpty(nextProps.onboarding.selected_seating_area)
            ? nextProps.onboarding.selected_seating_area
            : "",
          hasSetEditProps: true,
        };
      }
    }
    return null;
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  // toggleFunction = (e) => {
  //   this.setState({
  //     [e.target.name]: e.target.checked,
  //   });
  // };
  toggleFunction = (e) => {
    this.setState({ checkedBox: !this.state.checkedBox });
  };
  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value });
  };

  onChangeTwo = (e) => {
    let editDiner = this.state.editNumberName;
    if (e.target.name === "name") {
      let data = e.target.value.split(" ");
      let newarray1 = [];
      for (let x = 0; x < data.length; x++) {
        newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
      }
      let newData = newarray1.join(" ");
      editDiner[e.target.name] = newData;
      this.setState({
        [e.target.name]: editDiner,
        actionButton: true,
      });
    } else if (e.target.name === "mobile_number") {
      const { value, maxLength } = e.target;
      const number = value.slice(0, maxLength);
      this.setState({
        [e.target.name]: number,
        actionButton: true,
      });
    } else {
      editDiner[e.target.name] = e.target.value;
      this.setState({
        editNumberName: editDiner,
        actionChange: true,
      });
    }
  };

  onChange = (e) => {
    let editDiner = this.state.editDiner;
    if (e.target.name === "occasion") {
      let caps = e.target.value;
      caps = caps.charAt(0).toUpperCase() + caps.slice(1);
      let dataSet = caps;
      editDiner[e.target.name] = dataSet;
      this.setState({
        [e.target.name]: editDiner,
        actionButton: true,
      });
    } else {
      editDiner[e.target.name] = e.target.value;
      this.setState({
        editDiner: editDiner,
        actionChange: true,
      });
    }
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  IncrementKidsItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.kids < 100) {
        return {
          kids: prevState.kids + 1,
        };
      } else {
        return null;
      }
    });
  };
  IncrementAdultItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.adult < 100) {
        return {
          adult: prevState.adult + 1,
        };
      } else {
        return null;
      }
    });
  };
  IncrementhandicapItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.handicap < 100) {
        return {
          handicap: prevState.handicap + 1,
        };
      } else {
        return null;
      }
    });
  };
  IncrementhighchairItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.highchair < 100) {
        return {
          highchair: prevState.highchair + 1,
        };
      } else {
        return null;
      }
    });
  };

  DecreaseKidsItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.kids > 0) {
        return {
          kids: prevState.kids - 1,
        };
      } else {
        return null;
      }
    });
  };

  DecreaseAdultItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.adult > 0) {
        return {
          adult: prevState.adult - 1,
        };
      } else {
        return null;
      }
    });
  };

  DecreaseHandicapItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.handicap > 0) {
        return {
          handicap: prevState.handicap - 1,
        };
      } else {
        return null;
      }
    });
  };
  DecreaseHighchairItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.highchair > 0) {
        return {
          highchair: prevState.highchair - 1,
        };
      } else {
        return null;
      }
    });
  };

  /***************************
   * @DESC on Button Handler
   ***************************/
  onButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      seating_preference: type,
      actionChange: true,
    });
  };

  onSubmitHandler = (e) => {
    e.preventDefault();
    let editNumberName = this.state.editNumberName;
    let editDiner = this.state.editDiner;
    const token = this.props.auth.user.accessToken;
    const vendor_id = this.props.auth.user.VendorUser._id;
    const diner_id = editDiner._id;
    const formData = {
      user_details: {
        country_code: editNumberName.country_code,
        mobile_number: editNumberName.mobile_number,
        name: editNumberName.name,
      },
      adult_count: this.state.adult,
      kids_count: this.state.kids,
      handicap_chair: this.state.handicap,
      high_chair: this.state.highchair,
      room_number: editDiner.room_number,
      table_number: editDiner.table_number,
      seating_preference: this.state.seating_preference,
      occasion: editDiner.occasion,
    };
    this.props.vendor_dashboard_edit_action(
      formData,
      diner_id,
      vendor_id,
      token
    );
    this.onCloseModal();
  };

  render() {
    const {
      // errors,
      seating_preference,
      open,
      editDiner,
      editNumberName,
      allSeatingArea,
    } = this.state;
    return (
      <div>
        {/* <PopupActionButton
          buttonText={this.props.buttonText}
          buttonType="button"
          buttonClass="cancel"
          onClick={this.onOpenModal}
        /> */}
        <PopupIconButtonReusable
          buttonClass={this.props.buttonClass}
          titleText="Edit Diner"
          image={require("../../../../assets/images/UserManagement/pencil.svg")}
          onClick={this.onOpenModal}
        />
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "add-diner-main-popup closeRemove",
            //edit-reusable-diner
            closeButton: "",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="d-flex align-items-center py-3 px-4">
            <span className="pr-3 cursor" onClick={this.onCloseModal}>
              <Image
                alt="Back"
                width="20px"
                src={require("../../../../assets/images/UserManagement/backIcon.svg")}
              />
            </span>
            <div className="f12-400 c_black">Edit Diner</div>
          </div>
          <div className="add-diner-reservation-topbar">
            <div className="">
              <div className="edit-reusable-diner">
                <Form noValidate onSubmit={this.onSubmitHandler}>
                  <EditDetailsTop
                    allPropsData={this.state.editDiner}
                    allPropsDataTwo={this.state.editNumberName}
                  />
                  <div className="mx-0 mb-3 w-100 border-0 sectionHeader f12-700 bg-yellow-light">
                    Edit Details Below
                  </div>
                  <Form.Row className="px-3">
                    <Col md={6}>
                      <Row>
                        <Col xs={4} className="pr-0">
                          <Form.Group
                            className="reusableInputComponent-main mb-0"
                            controlId={"country_code"}
                          >
                            <div className="input-phone-country-code-reusable w-100">
                              <select
                                name="country_code"
                                value={this.state.country_code}
                                onChange={this.onChangeTwo}
                              >
                                <option value={this.state.country_code}>
                                  {editNumberName.country_code}
                                </option>
                                {getCountries().map((country) => (
                                  <option
                                    key={country}
                                    value={"+" + getCountryCallingCode(country)}
                                  >
                                    {en[country]} (+
                                    {getCountryCallingCode(country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Form.Group>
                        </Col>
                        <Col xs={8}>
                          <Form.Group>
                            <TextField
                              id="outlined-basic"
                              label="Phone Number"
                              variant="outlined"
                              className="w-100"
                              type="number"
                              name="mobile_number"
                              onChange={this.onChangeTwo}
                              onKeyDown={InputNumberFunc}
                              onFocusOut={this.onFocusOut}
                              value={this.state.mobile_number}
                              required="required"
                              maxLength="10"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <TextField
                          id="outlined-basic"
                          label="Name"
                          variant="outlined"
                          className="w-100"
                          onChange={this.onChangeTwo}
                          value={editNumberName.name}
                          required="required"
                          type="text"
                          onKeyDown={InputCharacterCheck}
                          inputProps={{
                            name: "name",
                            maxLength: 50,
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <hr />
                  <Form.Row className="px-3">
                    <div className="col-12">
                      <div className="f16-500 py-3">Party Size</div>
                      {/* <div className="row margin-top-section">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <IncrementDecrement
                            iconImage={require("../../../../assets/images/AuthImages/children.svg")}
                            title="Kids"
                            iconText="Kids"
                            decreaseItem={this.DecreaseKidsItem}
                            incrementItem={this.IncrementKidsItem}
                            name="kids_count"
                            onChange={this.onChange}
                            quantity={this.state.kids}
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <IncrementDecrement
                            iconImage={require("../../../../assets/images/AuthImages/employees.svg")}
                            title="Adult"
                            iconText="Adult"
                            decreaseItem={this.DecreaseAdultItem}
                            incrementItem={this.IncrementAdultItem}
                            onChange={this.onChange}
                            quantity={this.state.adult}
                            name="adult_count"
                          />
                        </div>
                      </div> */}
                      <div className="d-flex enPartySize">
                        <div className="d-flex pr-3 pb-3">
                          <div className="enKidsIcon">
                            <Image
                              src={require("../../../../assets/images/ActionImages/children.png")}
                              alt="View"
                              title="View"
                              width="9px"
                            />
                          </div>
                          <div className="pl-2 enPartyPersonEdit">
                            <div className="f14-500 pb-2">Kids</div>
                            <div className="d-flex align-items-center">
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={this.DecreaseKidsItem}
                              >
                                <Image
                                  src={require("../../../../assets/images/UserManagement/minus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                              <input
                                placeholder="00"
                                className="enInputValueOnly f12-700"
                                value={this.state.kids}
                                name="kids_count"
                                onChange={this.onChange}
                                readOnly
                              />
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={this.IncrementKidsItem}
                              >
                                <Image
                                  src={require("../../../../assets/images/UserManagement/plus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex pl-3 pb-3">
                          <div className="enKidsIcon">
                            <Image
                              src={require("../../../../assets/images/ActionImages/employees.png")}
                              alt="View"
                              title="View"
                              width="9px"
                            />
                          </div>
                          <div className="pl-2 enPartyPersonEdit">
                            <div className="f14-500 pb-2">Adult</div>
                            <div className="d-flex align-items-center">
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={this.DecreaseAdultItem}
                              >
                                <Image
                                  src={require("../../../../assets/images/UserManagement/minus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                              <input
                                placeholder="00"
                                className="enInputValueOnly f12-700"
                                value={this.state.adult}
                                onChange={this.onChange}
                                name="adult_count"
                                readOnly
                              />
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={this.IncrementAdultItem}
                              >
                                <Image
                                  src={require("../../../../assets/images/UserManagement/plus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form.Row>
                  <hr />
                  <Form.Row className="px-3">
                    <div className="col-12">
                      <div className="col-12 p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div className="f16-700">
                          Need Handicap accessor a Highchair?
                        </div>
                        {/* <SlidingComponent
                          name="currentState"
                          currentState={
                            this.state.highchair === 0 &&
                            this.state.handicap === 0
                              ? false
                              : true
                          }
                          spantext1="No"
                          spantext2="Yes"
                          type={"checkbox"}
                          toggleclass={"toggle d-flex align-items-center mb-2"}
                          toggleinputclass={"toggle__switch"}
                          onChange={this.toggleFunction}
                          // slidingonClick={this.onSelecttogglestatusChange(data)}
                          defaultChecked={
                            this.state.highchair === 0 &&
                            this.state.handicap === 0
                              ? false
                              : true
                          }
                        /> */}
                        <div className="d-flex align-items-center py-2">
                          <div className="f16-500 mr-2">No</div>
                          <Switch
                            onChange={this.toggleFunction}
                            checked={this.state.checkedBox}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={15}
                            width={41}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                            // disabled={disabled === true ? true : false}
                          />
                          <div className="f16-500 ml-2">Yes</div>
                        </div>
                      </div>
                      {this.state.checkedBox === false ? null : (
                        <div className="d-flex enPartySize pb-4">
                          <div className="d-flex pr-3 pb-3">
                            <div className="enKidsIcon">
                              <Image
                                src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                                alt="View"
                                title="View"
                                className="custom"
                              />
                            </div>
                            <div className="pl-2 enPartyPersonEdit">
                              <div className="f14-500 pb-2">Handicap</div>
                              <div className="d-flex align-items-center">
                                <Button
                                  variant="link"
                                  className="p-0"
                                  onClick={this.DecreaseHandicapItem}
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/minus.svg")}
                                    alt="Minus"
                                    title="Minus"
                                    fluid
                                  />
                                </Button>
                                <input
                                  placeholder="00"
                                  className="enInputValueOnly f12-700"
                                  value={this.state.handicap}
                                  onChange={this.onChange}
                                  name="handicap_chair"
                                  readOnly
                                />
                                <Button
                                  variant="link"
                                  className="p-0"
                                  onClick={this.IncrementhandicapItem}
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/plus.svg")}
                                    alt="Minus"
                                    title="Minus"
                                    fluid
                                  />
                                </Button>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex pl-3 pb-3">
                            <div className="enKidsIcon">
                              <Image
                                src={require("../../../../assets/images/ActionImages/highchair.svg")}
                                alt="View"
                                title="View"
                                className="custom"
                              />
                            </div>
                            <div className="pl-2 enPartyPersonEdit">
                              <div className="f14-500 pb-2">Highchair</div>
                              <div className="d-flex align-items-center">
                                <Button
                                  variant="link"
                                  className="p-0"
                                  onClick={this.DecreaseHighchairItem}
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/minus.svg")}
                                    alt="Minus"
                                    title="Minus"
                                    fluid
                                  />
                                </Button>
                                <input
                                  placeholder="00"
                                  className="enInputValueOnly f12-700"
                                  onChange={this.onChange}
                                  value={this.state.highchair}
                                  name="high_chair"
                                  readOnly
                                />
                                <Button
                                  variant="link"
                                  className="p-0"
                                  onClick={this.IncrementhighchairItem}
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/plus.svg")}
                                    alt="Minus"
                                    title="Minus"
                                    fluid
                                  />
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* <div className="row mt-4">
                        {this.state.highchair === 0 ? null : (
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <IncrementDecrement
                              iconImage={require("../../../../assets/images/AuthImages/wheelchair.svg")}
                              title="Handicap"
                              iconText="Handicap"
                              decreaseItem={this.DecreaseHandicapItem}
                              incrementItem={this.IncrementhandicapItem}
                              onChange={this.onChange}
                              quantity={this.state.handicap}
                              name="handicap_chair"
                            />
                          </div>
                        )}
                        {this.state.handicap === 0 ? null : (
                          <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <IncrementDecrement
                              iconImage={require("../../../../assets/images/AuthImages/highchair.svg")}
                              title="Highchair"
                              iconText="Highchair"
                              decreaseItem={this.DecreaseHighchairItem}
                              incrementItem={this.IncrementhighchairItem}
                              onChange={this.onChange}
                              quantity={this.state.highchair}
                              name="high_chair"
                            />
                          </div>
                        )}
                      </div> */}
                    </div>
                  </Form.Row>
                  <hr />
                  <Form.Row className="px-3">
                    <div className="col-6">
                      <Form.Group>
                        <TextField
                          id="outlined-basic"
                          label="Room Number"
                          variant="outlined"
                          className="w-100"
                          onChange={this.onChange}
                          value={editDiner.room_number}
                          required="required"
                          type="text"
                          onKeyDown={InputCharacterCheck}
                          inputProps={{
                            name: "room_number",
                          }}
                        />
                      </Form.Group>
                      {/* <div className="col-7 col-sm-7 col-md-6 col-lg-4 col-xl-4 small-device-width-input">
                        <InputBoxComponent
                          displayLabel={false}
                          controlId="room_number"
                          inputType="number"
                          placeHolder="Room No."
                          name="room_number"
                          onChange={this.onChange}
                          value={editDiner.room_number}
                          required="required"
                          showBottom={true}
                          error={errors.room_number}
                          inputClassName={classnames(
                            "input-component-inputfield",
                            {
                              invalid: errors.room_number,
                            }
                          )}
                        />
                      </div> */}
                    </div>
                    <div className="col-6">
                      <Form.Group>
                        <TextField
                          id="outlined-basic"
                          label="Table Number"
                          variant="outlined"
                          className="w-100"
                          onChange={this.onChange}
                          value={editDiner.table_number}
                          required="required"
                          type="text"
                          onKeyDown={InputCharacterCheck}
                          inputProps={{
                            name: "table_number",
                          }}
                        />
                      </Form.Group>
                      {/* <div className="col-7 col-sm-7 col-md-6 col-lg-4 col-xl-4 small-device-width-input">
                        <InputBoxComponent
                          displayLabel={false}
                          controlId="table_number"
                          inputType="number"
                          placeHolder="Table No."
                          name="table_number"
                          onChange={this.onChange}
                          value={editDiner.table_number}
                          required="required"
                          showBottom={true}
                          error={errors.table_number}
                          inputClassName={classnames(
                            "input-component-inputfield",
                            {
                              invalid: errors.table_number,
                            }
                          )}
                        />
                      </div> */}
                    </div>
                  </Form.Row>
                  <hr />
                  <Form.Row className="px-3">
                    <div className="col-12">
                      <div className="f16-700 pb-2">Seating Preference</div>
                      <div className="f12-400 opacity5">
                        Your Preference will be considered. Seating is a subject
                        to availability.
                      </div>
                    </div>
                  </Form.Row>
                  <Form.Row className="px-3 pt-3">
                    {allSeatingArea.map((icon, index) => (
                      <div
                        className="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 mb-3"
                        key={index}
                      >
                        <IconBoxReusableComponent
                          classSection={
                            seating_preference === icon.title
                              ? "seating-Iconbox-reusable seating-Iconbox-reusable-active"
                              : "seating-Iconbox-reusable"
                          }
                          title={icon.title}
                          iconText={icon.title}
                          onClick={(e) => this.onButtonClick(e, icon.title)}
                        />
                      </div>
                    ))}
                  </Form.Row>
                  <hr />
                  <Form.Row className="px-3">
                    <div className="col-12 mb-3">
                      <Form.Label className="f16-700">
                        Special Occasion
                      </Form.Label>
                    </div>
                    <div className="col-12 mb-3 pb-5">
                      <Form.Group>
                        <TextField
                          id="special_Ocassion"
                          multiline
                          rows={5}
                          placeholder="eg. Wedding Anniversary"
                          variant="outlined"
                          className="w-100"
                          onChange={this.onChange}
                          value={editDiner.occasion}
                          type="text"
                          inputProps={{
                            name: "occasion",
                          }}
                        />
                      </Form.Group>
                      {/* <TextAreaReusableComponent
                        controlId="special_Ocassion"
                        displayText={false}
                        labelText="Address"
                        labelTextClass="text-area-lable"
                        placeholder="eg. Wedding Anniversary"
                        rows="5"
                        onChange={this.onChange}
                        name="occasion"
                        value={editDiner.occasion}
                        inputClassName={classnames(
                          "input-text-area text-area-new",
                          {
                            invalid: errors.special_Ocassion,
                          }
                        )}
                        error={errors.special_Ocassion}
                      /> */}
                    </div>
                  </Form.Row>
                  <div className="d-flex justify-content-center py-2 border-top fixed-bottom bg-white">
                    <PopupActionButton
                      buttonText="Cancel"
                      buttonType="button"
                      buttonClass={"noButton"}
                      onClick={this.onCloseModal}
                    />
                    <div className="ml-2">
                      <PopupActionButton
                        buttonText="Save"
                        buttonType={
                          this.state.actionButton === true ? "Submit" : "button"
                        }
                        buttonClass={"yesButton"}
                      />
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

EditDiner.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_dashboard_edit_action,
})(withRouter(EditDiner));
